import { useFeatureFlagEnabled } from "posthog-js/react";

export const useOnboardingv2ForDashboardCheck = (): boolean => {
    const isKlashaMerchantDashboardV2Active = useFeatureFlagEnabled('isOnboardingv2ForDashboardCheck')
    return isKlashaMerchantDashboardV2Active ?? true
}